var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"autoplayerWrapper"},[_vm._t("default"),_c('div',{ref:"videoPlayer",staticClass:"video-player",attrs:{"isplayingvideo":_vm.isPlayingVideo,"data-vimeo-url":_vm.vimeoVideoUrl,"id":_vm.playerId}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }